import GrowegyLogo from '../assets/images/growegy-logo.png';
import React, { PropsWithChildren } from 'react';
import { QueryStatus } from '@tanstack/react-query';
import { SwitchUser } from './components/SwitchUser';

export const SplashScreen = (props: PropsWithChildren<{ queryStatus: QueryStatus }>) => {
  const { queryStatus } = props;
  return (
    <div className="app-splash-screen__container">
      <img src={GrowegyLogo} alt="Growegy logo" />
      <div>{props.children}</div>
      {queryStatus === 'error' && <SwitchUser />}
    </div>
  );
};
